import { PRODUCERS_COLUMN_LABEL } from '@/modules/entity-management/constants/producersColumn.constant';

/** Whether a file's header carries the Producers column, beyond the one a custom property of that name
 * would own. `customPropertyNames` names the account's custom-property columns the way the file's layout
 * does: by label in a worksheet, by key in a Download Data file. */
export function hasProducersColumn(header: string[], customPropertyNames: string[]): boolean {
    const producersColumns = header.filter((label) => label.trim() === PRODUCERS_COLUMN_LABEL).length;
    const claimedByCustomProperty = customPropertyNames.includes(PRODUCERS_COLUMN_LABEL) ? 1 : 0;
    return producersColumns > claimedByCustomProperty;
}
